import styled from 'styled-components';
import { forIPhone5 } from '@westwing/ui-kit/breakPoints';

export default styled.p`
    font-size: 2em;
    font-family: ${({ theme }) => theme.fontChronicleRoman};
    color: ${({ theme }) => theme.colors.charcoal100};
    margin-bottom: 0;
    margin-top: 0;
    text-align: center;

    ${forIPhone5`
        margin-bottom: 5px;
        font-size: 1.5em;
    `}
`;
